export const TRACE_EVENT_POPUP_CONFIG = {
  gapBetweenBlocks: 18,
  // Popup layout
  popupPaddingMobile: 15,
  popupPaddingTop: 37,
  popupPaddingBottom: 15,
  popupPaddingHorizontal: 15,
  bottomMargin: 20,
  // Fixed header section heights (approximate)
  headerMarginBottom: 8,
  headerRowHeight: 40,
  statusRowHeight: 30,
  // Detail info container
  detailInfoPaddingHorizontal: 15,
  detailInfoPaddingVertical: 10,
  // Two-phase scroll
  innerScrollHeightOffset: 36,
  scrollBottomThreshold: 1,
  scrollEventThrottle: 16,
};
